import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import Hls from 'hls.js';
import flvjs from 'flv.js';
import { LocalService } from './local.service';

@Component({
  selector: 'nc-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.less']
})
export class VideoComponent implements OnInit, OnDestroy {
  video!: HTMLVideoElement;
  hls!: Hls;
  flv!: any;
  videoUrl: string = '';
  videoHover: boolean = false;
  playError: boolean = false;
  @Input() set ncUrl(value: string) {
    this.videoUrl = value;
    setTimeout(() => {
      //加延迟，防止其他传入参数未获取到
      this.initVideo();
    })
  };
  @Input() ncCoverUrl: string = '';//封面图片地址
  @Output() ncLoaded = new EventEmitter<HTMLVideoElement>();//返回video
  @Output() ncPlaying = new EventEmitter<boolean>();//返回播放状态

  //静音
  @Input() set ncMuted(value: boolean | string) {
    this.mutedMode = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  //自动播放
  @Input() set ncAutoplay(value: boolean | string) {
    this.autoplayMode = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  //循环播放
  @Input() set ncLoop(value: boolean | string) {
    this.loopMode = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  //铺满
  @Input() set ncFill(value: boolean | string) {
    this.fillMode = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  //截图
  @Input() set ncScreenshot(value: boolean | string) {
    this.screenshotMode = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  //封面
  @Input() set ncCover(value: boolean | string) {
    this.coverMode = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  //隐藏控制栏
  @Input() set ncControls(value: boolean | string) {
    this.controlsMode = value !== null && value !== undefined && value !== false && value !== 'false';
  }

  mutedMode: boolean = true;
  autoplayMode: boolean = false;
  loopMode: boolean = false;
  fillMode: boolean = false;
  screenshotMode: boolean = false;
  coverMode: boolean = false;
  controlsMode: boolean = true;

  constructor(private eleRef: ElementRef, private ls: LocalService) { }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {
    this.destroyAll();
  }

  //初始化
  async initVideo() {
    this.destroyAll();//加载前先销毁
    this.video = this.eleRef.nativeElement.querySelector('#video');//获取video
    const extension: string = this.ls.getFileExtension(this.videoUrl);//判断地址类型

    if (extension == 'm3u8') {
      //hls(m3u8)
      if (this.video.canPlayType('application/vnd.apple.mpegurl')) {
        this.video.src = this.videoUrl;
      } else if (Hls.isSupported()) {
        this.hls = new Hls();
        this.hls.loadSource(this.videoUrl);
        this.hls.attachMedia(this.video);
        //错误监听
        this.hls.on(Hls.Events.ERROR, (event, data) => {
          if (data.details == 'bufferStalledError') {
            console.warn('warning:', data.error)
          } else if (data.details == 'fragParsingError') {
            console.warn('warning:', data.error)
          } else if (data.details == 'bufferNudgeOnStall') {
            console.warn('warning:', data.error)
          } else {
            this.playError = true;
            console.error('error:', data.details);
            console.error('error:', data.error);
          }
        });
      }
    } else if (extension == 'flv') {
      //HTTP-FLV(flv)
      if (flvjs.isSupported()) {
        this.flv = flvjs.createPlayer({
          type: 'flv',
          url: this.videoUrl
        });
        this.flv.attachMediaElement(this.video);
        this.flv.load();
        //错误监听
        this.flv.on(flvjs.Events.ERROR, (error: any) => {
          this.playError = true;
          console.error('error:', error);
        })
      }
    } else {
      //静态视频地址
      this.video.src = this.videoUrl;
    }

    //封面
    if (this.coverMode) {
      const img: HTMLImageElement = document.createElement('img');
      img.style.width = '100%';
      img.style.height = '100%';
      const coverDom: HTMLElement = this.eleRef.nativeElement.querySelector('.cover');
      this.video.addEventListener('play', () => {
        coverDom.style.display = 'none';
      });
      if (!this.ncCoverUrl) {
        //使用默认封面
        const dataUrl: string = await this.captureVideoFrame(this.videoUrl);
        img.src = dataUrl;
      } else {
        //使用传入封面
        img.src = this.ncCoverUrl;
      }
      coverDom.appendChild(img);
    }

    //播放监听
    this.video.addEventListener('play', () => {
      this.ncPlaying.emit(true);
    });

    //暂停监听
    this.video.addEventListener('pause', () => {
      this.ncPlaying.emit(false);
    });

    //返回video对象
    this.ncLoaded.emit(this.video);
  }

  //截图
  screenshot() {
    const canvas: HTMLCanvasElement = document.createElement('canvas');
    canvas.width = this.video.videoWidth;
    canvas.height = this.video.videoHeight;
    canvas.getContext('2d')!.drawImage(this.video, 0, 0, canvas.width, canvas.height);

    const a: HTMLAnchorElement = document.createElement('a');
    a.download = '截图【' + this.ls.formatDate('yyyy-MM-dd HH-mm-ss') + '】';
    a.href = canvas.toDataURL('image/png');
    a.click();
  }

  //销毁
  destroyAll() {
    if (this.hls) {
      this.hls.destroy();
    }
    if (this.flv) {
      this.flv.destroy();
    }
    if (this.video) {
      this.destroyVideo(this.video);
    }
  }

  destroyVideo(video: HTMLVideoElement) {
    video.pause();
    video.src = '';
    video.removeEventListener('play', () => { });
    video.removeEventListener('pause', () => { });
    video.removeEventListener('loadedmetadata', () => { });
    video.remove();
  }

  //获取视频截图作为封面
  captureVideoFrame(url: string, time: number = 1) {
    return new Promise<string>((resolve) => {
      const video: HTMLVideoElement = document.createElement('video');
      video.crossOrigin = "anonymous"
      video.currentTime = time;
      video.muted = true;
      video.autoplay = true;

      const extension: string = this.ls.getFileExtension(url);//判断地址类型
      let hls: Hls;
      let flv: any;

      if (extension == 'm3u8') {
        //hls(m3u8)
        hls = new Hls();
        hls.loadSource(url);
        hls.attachMedia(video);
      } else if (extension == 'flv') {
        //HTTP-FLV(flv)
        flv = flvjs.createPlayer({
          type: 'flv',
          url: url
        });
        flv.attachMediaElement(video);
        flv.load();
      } else {
        //静态视频地址
        video.src = url;
      }

      video.addEventListener('loadedmetadata', () => {
        video.oncanplay = () => {
          const canvas: HTMLCanvasElement = document.createElement('canvas');
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          canvas.getContext('2d')!.drawImage(video, 0, 0, canvas.width, canvas.height);
          const dataUrl: string = canvas.toDataURL('image/png');
          resolve(dataUrl);
          if (hls) {
            hls.destroy();
          }
          if (flv) {
            flv.destroy();
          }
          if (video) {
            this.destroyVideo(video);
          }
        }
      });
    })
  }
}
